module.exports = "/images/vendor/desiigner-svg/svg/logos/lonelyplanet-globe.svg?e3654ba1b442968a98b402aac6d7901f";